import { render, staticRenderFns } from "./AvailabilityIntervalsForm.vue?vue&type=template&id=68af18d6&scoped=true"
import script from "./AvailabilityIntervalsForm.vue?vue&type=script&lang=js"
export * from "./AvailabilityIntervalsForm.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityIntervalsForm.vue?vue&type=style&index=0&id=68af18d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af18d6",
  null
  
)

export default component.exports